const timeOptions: Intl.DateTimeFormatOptions = {
    hour: "2-digit",
    minute: "2-digit",
  };
  
  export const formatTime = (time: string, date: string) => {
    return new Date(`${date}T${time}+03:00`).toLocaleTimeString(
      "ar",
      timeOptions
    );
  };
  